import {view, useIsMobileAndTouchCheck} from '@sail/ui';
import {CONTENT_WIDTH} from 'src/utils/constants';

export const ScreenWrapper = ({
  alwaysCentered,
  children,
  setDistribute,
}: {
  alwaysCentered?: boolean;
  children: React.ReactNode;
  setDistribute?: boolean;
}) => {
  const isMobile = useIsMobileAndTouchCheck();
  const shouldCenter = alwaysCentered ? true : !isMobile;

  // Space between if alwaysCentered to vertically center, else packed to align to top
  const distribute = shouldCenter ? 'space-between' : 'packed';

  return (
    <view.div
      css={{
        width: 'fill',
        minWidth: CONTENT_WIDTH,
        height: '100dvh',
        overflow: 'auto', // Allow scroll bar if content is too long
        position: 'relative', // This allows the fixed header to scroll with the rest of the content
        padding: 'large', // Pad 24px all around
        stack: 'y',
        alignX: 'center', // Center horizontally
        alignY: shouldCenter ? 'center' : 'top', // Center vertically if alwaysCentered, else align to top
        distribute: setDistribute ? distribute : undefined, // We only want to distribute when there are multiple items (i.e. pageheader and children)
        gap: 'large',
      }}
      data-testid="screen-wrapper"
    >
      {children}
    </view.div>
  );
};
